import { INTERPRETER_AUDIO, INTERPRETER_VIDEO } from '../constants/interpreter.constants';
import { GUEST_INVITE_TEXT, GUEST_INVITE_AUDIO } from '../constants/guest.constants';
import { ALLOWED_INVISIT_MENU_ITEMS } from '../constants/tab.constants';
import translations from '../translations';
import { NUID_ID_TYPE } from '../constants/app.constants';
import { ZOOM_POLL_DETAIL_QUESTION_TYPE } from '../constants/polls.constant';

export const getRadioButtonsForInterpreter = () => {
  const RadioButtons = [];
  RadioButtons.push(
    {
      label: 'Video',
      name: 'interpreterType',
      value: INTERPRETER_VIDEO,
      checked: true
    },
    {
      label: 'Audio',
      name: 'interpreterType',
      value: INTERPRETER_AUDIO,
      checked: false
    }
  );

  return {
    RadioButtons
  };
};

export const getRadioButtonsForGuest = () => {
  const RadioButtons = [];
  RadioButtons.push(
    {
      label: 'Video',
      name: 'guestInvitationType',
      value: GUEST_INVITE_TEXT,
      checked: true
    },
    {
      label: 'Audio',
      name: 'guestInvitationType',
      value: GUEST_INVITE_AUDIO,
      checked: false
    }
  );
  return {
    RadioButtons
  };
};

export const getRadioButtonsForGuestAndPatient = () => {
  const RadioButtons = [];

  RadioButtons.push(
    {
      label: 'Guest',
      name: 'guestPatientInvitationType',
      value: 'GUEST',
      title: 'Guest',
      checked: true
    },
    {
      label: 'Patient',
      name: 'guestPatientInvitationType',
      value: 'PATIENT',
      title: 'Patient'
    }
  );

  return {
    RadioButtons
  };
};

export const getErrorModalProps = err => {
  const translation = translations.ERROR_CODES;
  let errorCode;
  if (err && err.response && err.response.data && err.response.data.errors) {
    const errorData = err.response.data.errors;
    if (errorData.length > 0) {
      errorCode = errorData[0].code;
    } else {
      errorCode = errorData.code;
    }
  } else {
    errorCode = err?.response?.status || err?.code || 500;
  }

  if (translation[errorCode]) {
    return translation[errorCode];
  }

  return null;
};

export const getCapitalizedName = name => {
  let splittedData = name.split(' ');
  splittedData = splittedData.map(val => {
    if (!val) return val;
    return val[0].toUpperCase() + val.substr(1, val.length - 1).toLowerCase();
  });
  return splittedData.join(' ');
};

export const validateAppInitializationDependencies = (dependencies, isDirectory) => {
  let isValidStatus = validateAppDependenciesForMeeting({ dependencies, isDirectory });
  if (isDirectory === true) {
    isValidStatus = isValidStatus && validateAppDependenciesisDirectory(dependencies);
  }
  return isValidStatus;
};

const validateAppDependenciesForMeeting = ({ dependencies, isDirectory }) => {
  const {
    appSettings: {
      appointment: { appointmentRegion = null, appointmentVisitType = null, provider: { nuid = null } = {} } = {},
      menuItems = [],
      directoryMenuDetails: { tabItems = null } = {}
    } = {}
  } = dependencies ?? {};
  const basicValidationStatus =
    appointmentRegion !== null &&
    appointmentRegion !== '' &&
    appointmentVisitType !== null &&
    appointmentVisitType !== '' &&
    nuid !== null &&
    nuid !== '';
  const validMenuItemStatus = Array.isArray(menuItems) && menuItems.length > 0 && menuItems.every(item => ALLOWED_INVISIT_MENU_ITEMS.includes(item));
  return isDirectory ? basicValidationStatus : basicValidationStatus && validMenuItemStatus && tabItems !== null;
};

const validateAppDependenciesisDirectory = dependencies => {
  const {
    directoryConfig: {
      features: {
        directory: { clinicianFilterDetails: { region: regionFilterDetails = null, providerType: providerTypeFilterDetails = null } = {} } = {}
      } = {}
    } = {}
  } = dependencies ?? {};
  return regionFilterDetails !== null && providerTypeFilterDetails !== null;
};

const prepareFirstAndLastName = fullName => {
  const nameSplits = fullName.split(' ');
  const [firstName, ...otherDetails] = nameSplits;
  const lastName = otherDetails.join(' ');
  return { firstName, lastName };
};

export const prepareProviderDetails = (setupResponse, uid) => {
  const {
    appointment: {
      appointmentRegion,
      provider: { nuid, providerName = '' }
    }
  } = setupResponse;
  const parsedNameDetails = prepareFirstAndLastName(providerName);
  return {
    id: nuid,
    idType: NUID_ID_TYPE,
    region: appointmentRegion,
    ...parsedNameDetails,
    zoomUid: uid
  };
};

export const formatTimestamp = timestamp => {
  const date = new Date(timestamp);
  const formattedTime = date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  return formattedTime.replace(/^(\d{1,2})\/(\d{1,2})\/(\d{4}),\s(.+)$/, '$4, $3/$1/$2');
};

export const attachHoverforEllipsedToolTip = (className, maxLength = 21) => {
  // Get all elements with the specified class name
  const elementList = document.getElementsByClassName(className);

  // Loop through each element
  for (let idx = 0; idx < elementList.length; idx++) {
    const element = elementList.item(idx);
    const fullText = element.innerHTML;

    // Truncate the text to maxLength with ellipsis if needed
    const displayText = fullText.length >= maxLength ? `${fullText.slice(0, maxLength - 1)}...` : fullText;
    element.innerHTML = displayText;
    // Set the title attribute to the full text for the tooltip
    if (fullText.length >= maxLength) {
      element.title = fullText;
    }
  }
};

export const removeToolTip = (className, preserveTitleValue = false) => {
  const elementList = document.getElementsByClassName(className);
  for (let idx = 0; idx < elementList.length; idx++) {
    const element = elementList.item(idx);
    if (preserveTitleValue) {
      element.dataset.originalTitleValue = element.hasAttribute('title') ? element.title : element.innerHTML;
    }
    if (element.hasAttribute('title')) {
      element.removeAttribute('title');
    }
  }
};

export const isOriginalTitleValuePreserved = className => {
  const elementList = document.getElementsByClassName(className);
  for (let idx = 0; idx < elementList.length; idx++) {
    const element = elementList.item(idx);
    if (element.dataset.originalTitleValue) {
      return true;
    }
  }
  return false;
};

export const copyPreservedTitleValueToInnerHtml = className => {
  const elementList = document.getElementsByClassName(className);
  for (let idx = 0; idx < elementList.length; idx++) {
    const element = elementList.item(idx);
    const titleValueExists = element.hasAttribute('data-original-title-value');
    if (titleValueExists) {
      element.innerHTML = element.dataset.originalTitleValue;
      if (element.hasAttribute('title')) {
        element.removeAttribute('title');
      }
      if (element.dataset.originalTitleValue) {
        delete element.dataset.originalTitleValue;
      }
    }
  }
};

export const adjustTextareaHeight = textarea => {
  textarea.style.height = '3rem';
  textarea.style.height = `${textarea.scrollHeight}px`;
};

export const maskPhoneNumber = phoneNumber => {
  if (typeof phoneNumber !== 'string') {
    return '';
  }
  const digits = phoneNumber.replace(/\D/g, '');
  if (digits.length !== 10) {
    return '';
  }
  const last4 = digits.slice(-4);
  return `XXX-XXX-${last4}`;
};

export const pollsAnswerFormatted = answers => {
  return (answers || '').replace(/;\s*/g, '; ');
};

export const sortAlphabetically = answers => {
  return [...answers].sort((a, b) => a.localeCompare(b));
};

export const attachRightAnswerMarkerIfNeeded = params => {
  const { rightAnswers, answer, questionType } = params;
  if (!questionType || !rightAnswers?.length) return false;

  const normalize = s => (s ?? '').trim().toLowerCase();
  const toNormalizedSet = arr => new Set(arr.map(normalize).filter(Boolean));

  const isSingleCorrect = () => {
    const a = normalize(answer);
    return rightAnswers?.some(ra => normalize(ra) === a) ?? false;
  };

  const isMultipleCorrect = () => {
    const answerStr = typeof answer === 'string' ? answer : (answer ?? '');
    const selectedSet = toNormalizedSet(answerStr.split(';'));
    const correctSet = toNormalizedSet(rightAnswers);
    if (selectedSet.size === 0 || correctSet.size === 0) return false;
    if (selectedSet.size !== correctSet.size) return false;

    return [...selectedSet].every(s => correctSet.has(s));
  };

  const isFillInBlankCorrect = () => {
    const correctSet = toNormalizedSet(rightAnswers);
    if (correctSet.size === 0) return false;

    // Format: "1:Food;2:WATER;3:sleep"
    const selectedValues = [];
    const answerStr = typeof answer === 'string' ? answer : String(answer ?? '');

    for (const part of answerStr.split(';')) {
      const p = part.trim();
      if (!p) continue; // skip empty segment like "" from "a;b;" and keep checking others

      const colonIdx = p.indexOf(':');
      if (colonIdx === -1) return false; // invalid format => not correct

      const value = p.slice(colonIdx + 1).trim();
      if (!value) return false; // "1:" => invalid => stop everything

      selectedValues.push(value);
    }

    const selectedSet = toNormalizedSet(selectedValues);

    if (selectedSet.size === 0) return false;
    if (selectedSet.size !== correctSet.size) return false;

    return [...selectedSet].every(v => correctSet.has(v));
  };

    // logic should exactly be same as multiple choice, but we are keeping it separate for clarity and future-proofing.
  const isMatchingCorrect = isMultipleCorrect;

  // logic should exactly be same as multiple choice, but we are keeping it separate for clarity and future-proofing.
  const isRankOrderCorrect = isMultipleCorrect;

  const evaluators = {
    [ZOOM_POLL_DETAIL_QUESTION_TYPE.single]: isSingleCorrect,
    [ZOOM_POLL_DETAIL_QUESTION_TYPE.multiple]: isMultipleCorrect,
    [ZOOM_POLL_DETAIL_QUESTION_TYPE.fill_in_the_blank]: isFillInBlankCorrect,
    [ZOOM_POLL_DETAIL_QUESTION_TYPE.matching]: isMatchingCorrect,
    [ZOOM_POLL_DETAIL_QUESTION_TYPE.rank_order]: isRankOrderCorrect,
  };

  return evaluators[questionType]?.() ?? false;
};
